/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ userName: NonNullable<unknown> }} Einvoice_Credential_ConnectedInputs */

const vi_einvoice_credential_connected = /** @type {(inputs: Einvoice_Credential_ConnectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kết nối thành công, tài khoản: ${i?.userName}`)
};

/**

* @param {Einvoice_Credential_ConnectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_connected = /** @type {((inputs: Einvoice_Credential_ConnectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_ConnectedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_connected(inputs)
});